import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_COOPERATION_HISTORY_REQUEST } from "./constants";
import { Action, CooperationHistoryState } from "./types";

function item(state: CooperationHistoryState = {}, action: Action): CooperationHistoryState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COOPERATION_HISTORY_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_COOPERATION_HISTORY_REQUEST:
      return true;
    case getSuccessActionType(FETCH_COOPERATION_HISTORY_REQUEST):
    case getFailureActionType(FETCH_COOPERATION_HISTORY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const cooperationHistory = combineReducers({ item, isFetching });
